import InnerComponent from '@Components/Purchase/Rfq/PublicRfq';
import React from "react";

const PublicRfq = () => (
    <div>
        <InnerComponent />
    </div>
);
export default PublicRfq;
